import { FC, ReactNode } from 'react';

const TermsDisplay = () => {
  return (
    <div className="grid relative gap-5">
      <h1 className="text-[19px]">Terms and Conditions</h1>

      <div className="grid gap-y-2 justify-between text-[16px]">
        <Title>1. Acceptance of Terms</Title>
        <Term>
          By accessing or using this website (the "Site"), you agree to comply
          with and be bound by these terms and conditions. If you do not agree
          to these terms, please do not use the Site.
        </Term>

        <Title>2. Use of the Site</Title>
        <Term>
          You agree to use the Site for lawful purposes only and in a manner
          consistent with all applicable local, national, and international laws
          and regulations.
        </Term>

        <Title>3. Intellectual Property</Title>
        <Term>
          All content on the Site, including text, graphics, logos, images, and
          software, is the property of [Your Company] and is protected by
          copyright and other intellectual property laws.
        </Term>

        <Title>4. Privacy Policy</Title>
        <Term>
          Your use of the Site is also governed by our Privacy Policy, which can
          be found [link to your privacy policy].
        </Term>

        <Title>5. Disclaimer of Warranties</Title>
        <Term>
          The Site is provided "as is" without any warranties, express or
          implied. [Your Company] makes no representations or warranties
          regarding the accuracy, completeness, or reliability of the content on
          the Site.
        </Term>

        <Title>6. Limitation of Liability</Title>
        <Term>
          [Your Company] will not be liable for any direct, indirect,
          incidental, special, or consequential damages arising out of or in any
          way connected with your use of the Site.
        </Term>

        <Title>7. Changes to Terms and Conditions</Title>
        <Term>
          [Your Company] reserves the right to modify these terms and conditions
          at any time. Your continued use of the Site after such modifications
          will constitute your acceptance of the updated terms.
        </Term>

        <Title>8. Governing Law</Title>
        <Term>
          These terms and conditions are governed by the laws of [Your
          Jurisdiction].
        </Term>

        <Title>9. Contact Information</Title>
        <Term>
          If you have any questions or concerns about these terms and
          conditions, please contact us at [Your Contact Information].
        </Term>
      </div>
    </div>
  );
};

const Title: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="pt-5">{children}</div>
);

const Term: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="text-bionic-muted">{children}</div>
);

export default TermsDisplay;
